export default {
  feedback: {
    login_success: 'Sesión iniciada correctamente',
    logout_success: 'Sesión cerrada correctamente',
  },
};
